import React, { useEffect, useMemo, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const DURACION_MS = 24 * 60 * 60 * 1000;
function dosDigitos(valor: number): string {
  return valor.toString().padStart(2, '0');
}
interface CountdownTimerProps {
  className?: string;
}
export function CountdownTimer({
  className = ''
}: CountdownTimerProps) {
  const limite = useMemo(() => Date.now() + DURACION_MS, []);
  const [restante, setRestante] = useState(DURACION_MS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRestante(Math.max(0, limite - Date.now()));
    }, 1000);
    return () => window.clearInterval(id);
  }, [limite]);
  const horas = Math.floor(restante / 3600000);
  const minutos = Math.floor(restante % 3600000 / 60000);
  const segundos = Math.floor(restante % 60000 / 1000);
  const bloques = [{
    valor: dosDigitos(horas),
    etiqueta: 'Horas'
  }, {
    valor: dosDigitos(minutos),
    etiqueta: 'Min'
  }, {
    valor: dosDigitos(segundos),
    etiqueta: 'Seg'
  }];
  return <div className={`rounded-xl border border-gold/40 bg-ink-900 p-3 ${className}`} style={{
    backgroundColor: "#CEFADA",
    backgroundImage: "none",
    borderColor: "#125563",
    paddingTop: "12px",
    paddingBottom: "12px",
    width: "311px"
  }} data-id="element-40" data-mp="1c0f8diyv2ox6">
      <p className="flex items-center justify-center gap-1.5 font-sans text-[10px] font-bold uppercase tracking-[0.14em] text-gold sm:text-xs" style={{
      color: "#082A31"
    }} data-id="element-41" data-mp="124263wp932qt">
        <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-42" data-mp="1us7qgice6pq4" />
        El precio de lanzamiento termina en
      </p>

      <div className="mt-2 flex items-start justify-center gap-2" role="timer" aria-live="off" aria-label={`Quedan ${horas} horas, ${minutos} minutos y ${segundos} segundos`} data-id="element-43" data-mp="1zpq2ihlphl2c">
        {bloques.map((bloque, index) => <React.Fragment key={bloque.etiqueta} data-id="element-44" data-mp="1pyn2lj4ijc4n" data-mpi={index}>
            {index > 0 && <span className="font-display text-2xl font-black leading-none text-gold/60 sm:text-3xl" aria-hidden="true" data-id="element-45" data-mp="2dozhjdy6e94q">
                :
              </span>}
            <span className="flex w-12 flex-col items-center rounded-lg bg-ink-800 py-1.5 sm:w-16 sm:py-2" style={{
          backgroundColor: "#082A31",
          backgroundImage: "none"
        }} data-id="element-46" data-mp="2scr41cmmq4lr">
              <span className="font-display text-2xl font-black leading-none text-cream tabular-nums sm:text-3xl" style={{
            color: "#F3E9E9"
          }} data-id="element-47" data-mp="2nbtl2xtsp6j7">
                {bloque.valor}
              </span>
              <span className="mt-1 font-sans text-[9px] font-semibold uppercase tracking-[0.12em] text-cream-300 sm:text-[10px]" data-id="element-48" data-mp="29dll0h1gpp3t">
                {bloque.etiqueta}
              </span>
            </span>
          </React.Fragment>)}
      </div>
    </div>;
}